import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '@routingModule';

import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { PrimengModule } from '@modules/primeng.module';
import { RegraConciliacaoAutomaticaComponent } from './components/regra-conciliacao-automatica.component';
import { RegraConciliacaoAutomaticaDialogComponent } from './components/dialogs/regra-conciliacao-automatica-dialog/regra-conciliacao-automatica-dialog.component';
import { RegraConciliacaoAutomaticaApiService } from './services/regra-conciliacao-automatica-api.service';
import { RegraConciliacaoAutomaticaResolver } from './regra-conciliacao-automatica.resolver';

@NgModule({
  declarations: [
    RegraConciliacaoAutomaticaComponent,
    RegraConciliacaoAutomaticaDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
  ],
  providers: [
    { provide: RegraConciliacaoAutomaticaApiService, useClass: RegraConciliacaoAutomaticaApiService },
    RegraConciliacaoAutomaticaResolver,
  ],
})
export class RegraConciliacaoAutomaticaModule { }
